import React, { Component } from 'react';
import logo from './images/KORU-logo.png';
import LoginErrorModal from "./LoginErrorModal";

const styles = {
    imgContainer:{
      textAlign: 'center',
      paddingTop: 50
    },

    logoImage: {
        width: 300
    },

    linkContainer: {
        textAlign: 'center',
        marginTop: 160
    },

    loginTitle: {
        textAlign: 'center',
        fontSize: 24,
        fontWeight: 300,
        color: 'white'
    },

    loginPage: {
      backgroundColor: 'rgb(36, 44, 90)',
      height: '100vh',
      paddingTop: 80

    },

    loginBtn: {
        width: '100%',
        height: 50,
        backgroundColor: 'rgb(165, 187, 52)',
        border: 'none',
        fontSize: 24,
        letterSpacing: '7.2px',
        color: 'white',
        cursor: 'pointer'
    },

    mainPage: {
      overflowY: 'none'
    },

    loginContainer: {
        margin: '0 auto'
    },

    footerText: {
        fontSize: 14,
        fontWeight: 300,
        color: 'white',
        textAlign: 'center',
        marginTop: 70
    }

}

class Login extends Component {

    constructor(props){
      super(props);
      this.state = {
            showModalWindow: false
        };
    }

    showModal(e){
        this.setState({showModalWindow: true});
        if(e){
            e.stopPropagation();
        }
    }

    closeModal(e){
        this.setState({showModalWindow: false});
        if(e) {
            e.preventDefault();
        }
    }

    login(){
        this.props.auth.authorize();
    }

    componentWillMount(){
        this.props.validateToken().then(()=>{
            window.location.replace('/calculator');
        });
    }

    componentDidMount(){
        if(this.props.wrongUrl){
            this.showModal();
        }
    }

    render(){
        return (
          <div className="container-fluid">
            <div className="row site-header">
                <div className="col-lg-12 col-xs-12 site-logo">
                    <a title="KORU Home" href="/">
                        <img src={logo} alt="KORU logo"/>
                    </a>
                </div>
            </div>
            <div className="row" style={styles.loginPage}>
                <div className="col-lg-4" style={styles.loginContainer}>
                    <div style={styles.loginTitle}>
                      <span>Flow Rate Calculator Sign In</span>
                  </div>
                  <div style={styles.linkContainer}>
                    <button style={styles.loginBtn} onClick={() => this.login()}>SIGN IN</button>
                  </div>
                  <div style={styles.footerText}>
                      <span>KORU Medical Systems. 24 Carpenter Road Chester, NY 10918 1-800-624-9600 or 1-845-469-2042</span>
                  </div>
                </div>
            </div>
            <LoginErrorModal showModal={() => this.showModal()} closeModal={(e) => this.closeModal(e)} showModalWindow={this.state.showModalWindow}/>
        </div>
        );
    }
}

export default Login;


// WEBPACK FOOTER //
// ./src/Login.js